import { RoutePath } from '../helpers/RoutePath';
import {
  Bug,
  CircleGauge,
  ClipboardCheck,
  FileChartPie,
  HandCoins,
  LayoutDashboard,
  Lightbulb,
  ShieldUser,
  TriangleAlert,
} from 'lucide-react';

export const getMenuItems = (userData, showThreatIntel, t) => {
  const { schema, userDetails, userRoles } = userData;
  const role = userDetails?.user?.role;
  const claims = userRoles?.claims || [];

  const isSitaAdminCase = schema === 'admin' && role === 'SitaAdmin';

  const isEtekAnalyst = role === 'EtekAnalyst';

  const menuItems = [];

  // Dashboard - always visible
  menuItems.push({
    label: t('dashboard'),
    path: RoutePath.DASHBOARD,
    icon: <LayoutDashboard width={18} height={18} />,
  });

  // If NOT (schema admin & role SitaAdmin)
  if (!isSitaAdminCase) {
    // Insights
    menuItems.push({
      label: t('insights'),
      path: RoutePath.INSIGHT,
      icon: <Lightbulb width={18} height={18} />,
    });

    // OEI
    menuItems.push({
      label: t('oei'),
      path: RoutePath.OEI,
      icon: <CircleGauge width={18} height={18} />,
    });

    // Risk + RoSI + ThreatIntel (if not EtekAnalyst)
    if (!isEtekAnalyst) {
      menuItems.push({
        label: t('risk'),
        path: RoutePath.RISK,
        icon: <TriangleAlert width={18} height={18} />,
      });

      menuItems.push({
        label: 'RoSI',
        path: RoutePath.ROSI,
        icon: <HandCoins width={18} height={18} />,
      });

      if (showThreatIntel) {
        menuItems.push({
          label: t('threatintel'),
          path: RoutePath.THREATINTEL,
          icon: <Bug width={18} height={18} />,
        });
      }
    }

    // Analysis Menu (Dropdown)
    if (claims.includes('Analysis_Menu')) {
      menuItems.push({
        label: t('analysis'),
        children: [
          {
            label: t('perspective'),
            path: RoutePath.PERSPECTIVEGRID,
          },
          {
            label: t('securitypulse'),
            path: RoutePath.SECURITYPULSEGRID,
          },
          {
            label: t('Advisory'),
            path: RoutePath.ADVISORY,
          },
          {
            label: t('mad'),
            path: RoutePath.MAD,
          },
        ],
        icon: <FileChartPie width={18} height={18} />,
      });
    }

    // Admin Menu
    if (claims.includes('Admin_Menu')) {
      menuItems.push({
        label: t('administrator'),
        path: RoutePath.ADMIN,
        icon: <ShieldUser width={18} height={18} />,
      });
    }
  }

  return menuItems;
};
